import {getFullName} from '@/_application/core/utils/common';
import {useUser} from '@/framework/user';
import {useState} from 'react';
import * as yup from 'yup';

export type UpdateInfoInput = {
    name: string;
    currentPassword?: string;
    newPassword?: string;
    newEmail?: string;
    isChangePassword?: boolean;
    isChangeEmail?: boolean;
};

const initialValue: UpdateInfoInput = {
    name: '',
    currentPassword: '',
    newPassword: '',
    newEmail: '',
    isChangePassword: false,
    isChangeEmail: false,
};

export const useUpdateCustomerInfoForm = () => {
    const {me, isLoading} = useUser();
    initialValue.name = getFullName(me.info);
    const [resetValues, setResetValues] = useState<UpdateInfoInput | null>(null);

    const newPasswordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
    const updateInfoRequestSchema = yup.object().shape({
        name: yup.string().required('Vui lòng nhập tên'),
        newPassword: yup.string().when('isChangePassword', {
            is: true,
            then: yup
                .string()
                .required('Vui lòng nhập mật khẩu mới')
                .matches(
                    newPasswordRegex,
                    'Mật khẩu phải chứa ít nhất một chữ số, một chữ thường, một chữ hoa và có ít nhất 8 ký tự',
                ),
            otherwise: yup.string().notRequired(),
        }),
        newEmail: yup.string().when('isChangeEmail', {
            is: true,
            then: yup.string().required('Vui lòng nhập email').email('Vui lòng nhập email đúng định dạng'),
            otherwise: yup.string().notRequired(),
        }),
        currentPassword: yup.string().when(['isChangePassword', 'isChangeEmail'], {
            is: (isChangePassword: boolean, isChangeEmail: boolean) => isChangePassword || isChangeEmail,
            then: yup.string().required('Vui lòng mật khẩu hiện tại'),
            otherwise: yup.string().notRequired(),
        }),
        isChangeEmail: yup.boolean(),
        isChangePassword: yup.boolean(),
    });

    return {
        isLoading: !initialValue.name ? true : isLoading,
        updateInfoRequestSchema,
        initialValue,
        resetValues,
        setResetValues,
    };
};
